// extracted by mini-css-extract-plugin
module.exports = {"content":"HomePage_content__3DSDE","title":"HomePage_title__2JQkh"};